import React, {useContext, useState, useEffect} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import CircularProgress from '@material-ui/core/CircularProgress';
// Form related
import { Field } from 'formik';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";

import NSA from "assets/NSA.pdf";
import CUF from "assets/CUF.pdf";

import { UserContext } from "../../../Models/UserContext";
import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const useStyles = makeStyles(connectionFormStyle);

const RepSign = (props) => {
    const classes = useStyles();
    const {formField, setFieldValue, values, currentModal, setCurrentModal} = props;
    const [disabled, setDisabled] = useState(false);
    let originalSignature = '';

    useEffect(() => {
        originalSignature = values[formField.representative_signature.name];
    },[]);

    const onCancel = () => {
        setFieldValue(formField.representative_signature.name, originalSignature);
        setCurrentModal("");
    };

    const onSubmit = () => {
        setDisabled(true);
        setTimeout(() => {
            setCurrentModal("EmailNotice");
            setDisabled(false);
        }, 1500);
    };

    return (
        <GridContainer>
            <GridItem xs>
                <Dialog open={currentModal === 'RepSign'} onClose={() => setCurrentModal("")} aria-labelledby="form-dialog-title">
                    <Card style={{width: "600px"}}>
                        <CardHeader color="primary">
                            <DialogTitle id="form-dialog-title" color="primary" className={classes.cardTitleWhite}>
                                Vodafone Representative Signing
                            </DialogTitle>
                        </CardHeader>
                        <CardBody>
                            <DialogContent>
                                <DialogContentText>
                                    Please sign below.
                                </DialogContentText>
                                <Field
                                    component={CustomInput}
                                    labelText={formField.representative_signature.label}
                                    name={formField.representative_signature.name}
                                    id={formField.representative_signature.name}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                />
                            </DialogContent>
                        </CardBody>
                        <DialogActions style={{paddingRight: "36px"}}>
                            <Button onClick={onCancel} color="info">
                                Cancel
                            </Button>
                            <div style={{position: "relative"}}>
                                <Button disabled={disabled} onClick={onSubmit} color="primary">
                                    Submit
                                </Button>
                                {disabled ? <CircularProgress size={18} className={classes.buttonProgress} /> : null}
                            </div>
                        </DialogActions>
                    </Card>
                </Dialog>

            </GridItem>
        </GridContainer>
    );
};

const EmailNotice = (props) => {
    const classes = useStyles();
    const {currentModal, setCurrentModal} = props;

    return (
        <GridContainer>
            <GridItem xs>
                <Dialog open={currentModal === 'EmailNotice'} onClose={() => setCurrentModal("")} aria-labelledby="form-dialog-title">
                    <Card style={{width: "600px"}}>
                        <CardHeader color="primary">
                            <DialogTitle id="form-dialog-title" color="primary" className={classes.cardTitleWhite}>
                                Submission Complete
                            </DialogTitle>
                        </CardHeader>
                        <CardBody>
                            <DialogContent>
                                <DialogContentText>
                                    Email has been sent to customer for signing.
                                </DialogContentText>
                            </DialogContent>
                        </CardBody>
                        <DialogActions style={{paddingRight: "36px"}}>
                            <Button onClick={() => setCurrentModal("")} color="primary">
                                Confirm
                            </Button>
                        </DialogActions>
                    </Card>
                </Dialog>

            </GridItem>
        </GridContainer>
    );
};

export default function Signing(props) {
    const user = useContext(UserContext);
    const [currentModal, setCurrentModal] = useState("");
    const classes = useStyles();
    const {formField, setFieldValue, values, isSubmitting} = props;

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Signing</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={6} sm={7}>
                                    <Field
                                        component={CustomInput}
                                        labelText="Customer Email"
                                        name={formField.email.name}
                                        id={formField.email.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            type: "email",
                                            readOnly: true,
                                            value: values[formField.email.name]
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText="Vodafone Rep Email"
                                        name="rep_email"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            readOnly: true,
                                            value: user.data.email_address
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={6} sm={5}>
                                    <GridContainer>
                                        <GridItem xs={12}>
                                            <Box className={classes.buttonBox}>
                                                <Button
                                                    disabled={isSubmitting}
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button + " " + classes.signingButton}
                                                    href={NSA}
                                                    target="_blank"
                                                >
                                                    Preview NSA
                                                </Button>
                                            </Box>
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <Box className={classes.buttonBox}>
                                                <Button
                                                    disabled={isSubmitting}
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button + " " + classes.signingButton}
                                                    href={CUF}
                                                    target="_blank"
                                                >
                                                    Preview CUF
                                                </Button>
                                            </Box>
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <Box className={classes.buttonBox}>
                                                <Button
                                                    disabled={isSubmitting}
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button + " " + classes.signingButton}
                                                    onClick={() => setCurrentModal("RepSign")}
                                                >
                                                    Initiate Signing Process
                                                </Button>
                                                <RepSign formField={formField} setFieldValue={setFieldValue} values={values} currentModal={currentModal} setCurrentModal={setCurrentModal} />
                                                <EmailNotice currentModal={currentModal} setCurrentModal={setCurrentModal} />
                                            </Box>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            &nbsp;
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
